import React from 'react'
import Select from 'react-select'

import { FormField } from '@/components/forms/FormField'

import {
  multiSelectStyles,
  selectTheme,
  Option,
  MultiValue,
  formatOptionWithDescription,
} from '../../helpers/selectHelpers'

export const MultiSelect = ({
  loading,
  options = [],
  fixedWidth,
  label,
  isDisabled,
  field: { name, value },
  form: { setFieldValue },
  condenseOptions = true,
  showFullOptions = false,
  maxUnCondensedOptions = 0,
  required,
  customOnChange,
  ...props
}) => {
  if (maxUnCondensedOptions) {
    condenseOptions = props.value?.length > maxUnCondensedOptions
  }
  const styles = multiSelectStyles(fixedWidth, condenseOptions, showFullOptions, props.isSelectAll)

  const components = {
    Option,
    ...(condenseOptions && { MultiValue }),
  }

  const handleChange = (option) => {
    setFieldValue(name, option)

    if (customOnChange) {
      customOnChange(option)
    }
  }

  return (
    <FormField required={required} data-testid={`${name}-multi-select`} {...props}>
      <label htmlFor={name}>{label}</label>
      <Select
        // Shared between the two MultiSelect components
        isMulti
        isClearable
        isSearchable
        closeMenuOnSelect={false}
        escapeClearsValue={false}
        hideSelectedOptions={false}
        backspaceRemovesValue={false}
        formatOptionLabel={formatOptionWithDescription}
        options={options}
        styles={styles}
        theme={(theme) => selectTheme(theme)}
        components={components}
        isLoading={loading}
        isDisabled={isDisabled}
        // Only used in this file
        onChange={handleChange}
        value={value}
        inputId={name}
        {...props}
      />
    </FormField>
  )
}
